module.exports = __webpack_public_path__ + "img/er-1.5ddd9371.png";